import { addFavorite, removeFavorite } from '@/js/api/favorite.ts';
import { getLocaleValue } from '@/js/helper/locale.ts';
import { ERROR_REQUEST_TEXT, getNotificationElement, showErrorNotify, showSuccessNotify } from '@/js/notification.ts';
import { computed, ref, watch } from 'vue';

const QUANTITY_SELECTOR = '.js-favorite-quantity';
const DATA_COUNTER = 'data-counter';
const favoriteElement = document.querySelector<HTMLElement>(QUANTITY_SELECTOR);

export function useFavorite() {
  const quantity = ref(0);
  const initialCounter = computed(() => favoriteElement?.dataset.counter ?? null);
  watch(initialCounter, (counter) => {
    quantity.value = counter !== null ? Number(counter) : 0;
  }, {
    immediate: true,
  });

  watch(quantity, (nextQuantity) => {
    favoriteElement?.setAttribute(DATA_COUNTER, nextQuantity.toString());
  });
  async function add(productId: number) {
    try {
      await addFavorite(productId);
      quantity.value += 1;
      showSuccessNotify({ node: getNotificationElement(getLocaleValue('product_added_to'), getLocaleValue('your_favorites_list'), '/wishlist') });
    }
    catch (e) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      console.log(e);
    }
  }

  async function remove(productId: number) {
    try {
      await removeFavorite(productId);
      if (quantity.value > 0) {
        quantity.value -= 1;
      }
      showErrorNotify({ text: getLocaleValue('product_has_been_removed_from_the_favorites_list') });
    }
    catch (e) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      console.log(e);
    }
  }

  return {
    add,
    remove,
  };
}
